export default "__VITE_ASSET__e3b39207__"